import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceFT(props) {
    const [datalist, setDatalist] = useState([]);

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        api_load()
        return () => {
            setDatalist([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading FT charge list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/refft/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.ft !== null && response.data.ft !== undefined) {
                    setDatalist(response.data.ft)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> FT Charge</h4>
                                    <p className="mb-0">Manage all parameter of fuel adjustment charge</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>FT Charge Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Year</th>
                                        <th className='text-center'>January</th>
                                        <th className='text-center'>February</th>
                                        <th className='text-center'>March</th>
                                        <th className='text-center'>April</th>
                                        <th className='text-center'>May</th>
                                        <th className='text-center'>June</th>
                                        <th className='text-center'>July</th>
                                        <th className='text-center'>August</th>
                                        <th className='text-center'>September</th>
                                        <th className='text-center'>October</th>
                                        <th className='text-center'>November</th>
                                        <th className='text-center'>December</th>
                                        <th>Edit Time</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.year}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.year}</td>
                                                <td className='text-center'>{data.m1 > 0 ? data.m1.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m2 > 0 ? data.m2.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m3 > 0 ? data.m3.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m4 > 0 ? data.m4.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m5 > 0 ? data.m5.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m6 > 0 ? data.m6.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m7 > 0 ? data.m7.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m8 > 0 ? data.m8.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m9 > 0 ? data.m9.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m10 > 0 ? data.m10.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m11 > 0 ? data.m11.toFixed(4) : "-"}</td>
                                                <td className='text-center'>{data.m12 > 0 ? data.m12.toFixed(4) : "-"}</td>
                                                <td>{data.edittime !== "-" ? data.edittime : "-"}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceFT